<template>
  <div>
    <div class="ibox-title">
      <h5>{{parseProviderName(providerName)}}</h5>
    </div>
    <div class="ibox-content">
      <div v-for="list in contactLists" :key="list.id">
        <el-card shadow="hover">
          <div class="row">
            <strong>
              <el-link 
                :underline="false"
                @click="$emit('onContactListClick', id, providerName, list)">
                {{list.name}}
              </el-link>
            </strong>
          </div>
          <div class="row"><span>Contact Count: {{list.contact_count}}</span></div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import contactListQuery from '@/graphql/contacts/contactList.gql';
import mailChimpListQuery from '@/graphql/contacts/mailChimpContactLists.gql';
import { parseProviderName } from '@/helpers/contact';

export default {
  name: 'ContactListItem',
  props: {
    id: String,
    providerName: String,
  },
  data: () => ({
    contactLists: [],
  }),
  apollo: {
    $client: 'apiv2',
    constantContactLists: {
      query: contactListQuery,
      skip: true,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loading }) {
        this.contactLists = !loading ? data.constantContactLists : [];
      },
    },
    mailChimpLists: {
      query: mailChimpListQuery,
      skip: true,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loading }) {
        this.contactLists = !loading ? data.mailChimpLists : [];
      },
    },
  },
  mounted() {
    switch (this.providerName) {
      case 'constant_contact':
        this.$apollo.queries.constantContactLists.start();
        break;
      case 'mail_chimp':
        this.$apollo.queries.mailChimpLists.start();
        break;
      default: break;
    }
  },
  methods: {
    parseProviderName,
  },
};
</script>


// WEBPACK FOOTER //
// ContactListItem.vue?26d0bdb2